import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IBaseModel } from "../models/base.model";
import { FlowInboxDirectory } from "../models/flow-inbox-directory.model";
import { BaseService } from "./base.service";
import { firstValueFrom } from "rxjs";
import { Utils } from '../shared/utils';

@Injectable({
    providedIn: 'root'
})
export class FlowInboxDirectoryService extends BaseService {
    controllerRoute = 'FlowInboxDirectory';

    constructor(httpClient: HttpClient) { 
        super(httpClient);
    }

    public async get(): Promise<IBaseModel<FlowInboxDirectory[]>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowInboxDirectory[]>>(url));
    }

    public async getById(id: string): Promise<IBaseModel<FlowInboxDirectory>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/${id}`;
        return await firstValueFrom(this.httpClient.get<IBaseModel<FlowInboxDirectory>>(url));
    }

    public async insert(data: FlowInboxDirectory): Promise<IBaseModel<void>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}`;
        return await firstValueFrom(this.httpClient.post<IBaseModel<void>>(url, data));
    }
    
    public async update(data: FlowInboxDirectory): Promise<IBaseModel<void>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}`;
        return await firstValueFrom(this.httpClient.put<IBaseModel<void>>(url, data));
    }

    public async delete(id: string): Promise<IBaseModel<void>> {
        const url = `${this.apiBaseUrl}/${this.controllerRoute}/${id}`;
        return await firstValueFrom(this.httpClient.delete<IBaseModel<void>>(url));
    }
}